import { jsxs as g, Fragment as y, jsx as s } from "react/jsx-runtime";
import { FileSelectorModal as E } from "@systemeio/file-manager";
import { useEditorState as v } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useState as b, useEffect as x } from "react";
import { twJoin as F } from "tailwind-merge";
import { LinkBubbleEdit as d, LinkBubbleView as B } from "./link-bubble-state.mjs";
import { BubbleMenu as w } from "../../components/bubble-menu/BubbleMenu.mjs";
const V = ({ editor: e, fileSource: o }) => {
  const l = v({
    editor: e,
    selector: ({ editor: n }) => ({
      href: n == null ? void 0 : n.getAttributes("link").href
    })
  }), t = l == null ? void 0 : l.href, [M, a] = b(!1), [c, i] = b(!1);
  x(() => {
    a(!t);
  }, [t]);
  const S = () => e == null ? void 0 : e.chain().focus().extendMarkRange("link").unsetLink().setMeta("addToHistory", !1).run(), f = (n) => {
    e && (a(!1), e.chain().focus().extendMarkRange("link").setLink({ href: n }).run());
  }, u = () => {
    if (!e) return;
    const n = e.state.schema.marks.link;
    if (!n) return;
    const { tr: r } = e.state;
    let m = !1;
    e.state.doc.descendants((p, h) => {
      p.marks.some((k) => k.type === n && !k.attrs.href) && (r.removeMark(h, h + p.nodeSize, n), m = !0);
    }), m && (r.setMeta("addToHistory", !1), e.view.dispatch(r));
  }, L = () => {
    a(!1), u();
  };
  return !e || !(e != null && e.options.editable) ? null : /* @__PURE__ */ g(y, { children: [
    /* @__PURE__ */ s(
      w,
      {
        className: F(c && "hidden"),
        editor: e,
        pluginKey: "linkBubbleMenu",
        options: {
          onHide: L
        },
        shouldShow: ({ editor: n }) => n.isActive("link"),
        children: /* @__PURE__ */ s("form", { onSubmit: (n) => n.preventDefault(), className: "flex items-center p-2", children: M ? /* @__PURE__ */ s(
          d,
          {
            initialValue: t ?? "",
            onSaveLink: f,
            openFileSelector: () => {
              e.commands.blur(), i(!0);
            }
          }
        ) : /* @__PURE__ */ s(B, { href: t ?? "", unsetLink: S, setIsEditing: a }) })
      }
    ),
    /* @__PURE__ */ s(
      E,
      {
        uploadingFromSource: o,
        initialSearchFilters: {
          source: [o],
          name: "",
          type: []
        },
        opened: c,
        onClose: () => {
          i(!1), u();
        },
        onSelect: (n) => {
          f(n.path), i(!1);
        }
      }
    )
  ] });
};
export {
  V as LinkBubbleMenu
};
